import * as React from "react";
const SvgAttio = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Attio_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F7F7F7",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#111418",
  d: "m21.793 15.15-1.671-2.605s-.006-.011-.01-.015l-.132-.206a1.35 1.35 0 0 0-1.148-.621l-2.692-.009-.187.294L12.736 17l-.179.277 1.349 2.096c.249.39.678.623 1.152.623h3.773c.466 0 .905-.239 1.15-.622l.133-.206.008-.008 1.672-2.607c.274-.43.274-.974 0-1.403zm-.51 1.091L19.61 18.85c-.007.013-.016.021-.024.033a.23.23 0 0 1-.362-.033l-1.673-2.61a.714.714 0 0 1-.003-.776l1.671-2.605.005-.007a.2.2 0 0 1 .133-.093q.026-.008.044-.009h.019a.23.23 0 0 1 .194.106l1.672 2.605a.72.72 0 0 1 0 .78h-.002zM16.85 8.848c.274-.429.274-.973 0-1.402l-1.671-2.605-.14-.22A1.36 1.36 0 0 0 13.885 4h-3.772c-.47 0-.9.234-1.151.621L2.208 15.153a1.28 1.28 0 0 0 0 1.401l1.81 2.825c.247.387.683.622 1.152.621h3.772a1.36 1.36 0 0 0 1.153-.622l.138-.213v-.008l1.349-2.096 3.99-6.22 1.275-1.99h.003zm-.395-.702a.7.7 0 0 1-.117.39L9.722 18.85a.233.233 0 0 1-.388 0l-1.67-2.609a.72.72 0 0 1 0-.78l6.613-10.308a.23.23 0 0 1 .195-.107.23.23 0 0 1 .194.106l1.671 2.605c.079.121.117.256.117.39"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Attio_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgAttio;
//# sourceMappingURL=Attio.js.map